module.exports = "/images/banner-04.jpg?467afbcd1a934c213314610f6e22bcfe";